import * as IconSelector from '../icons';

// Constantes exportadas
export const REPRESENTATION_ROL_INSPECTOR = 'Inspector';
export const REPRESENTATION_ROL_AUDITOR = 'Auditor';
export const REPRESENTATION_ROL_FORMADOR = 'Formador';
export const REPRESENTATION_ROL_OBSERVADOR = 'Observador';

// Definición del enum
export const representationRol = [
    {
        value: null,
        label: 'Sin definir',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: REPRESENTATION_ROL_INSPECTOR,
        label: 'Inspector',
        description: 'Hace de Inspector',
        icon: IconSelector.PointIcon,
        color: 'BLue'
    },
    {
        value: REPRESENTATION_ROL_AUDITOR,
        label: 'Auditor',
        description: 'Hace de Auditor',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: REPRESENTATION_ROL_FORMADOR,
        label: 'Formador',
        description: 'Hace de Formador',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: REPRESENTATION_ROL_OBSERVADOR,
        label: 'Observador',
        description: 'Hace de Observador',
        icon: IconSelector.PointIcon,
        color: 'DarkOrange'
    }
];
